module.exports = __webpack_public_path__ + "static/media/krunknown.4a476d12.svg";